/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type children_CreateAllergyRequest = {
    comment?: string;
    name: string;
    severity?: children_CreateAllergyRequest.severity;
};
export namespace children_CreateAllergyRequest {
    export enum severity {
        MILD = 'MILD',
        MODERATE = 'MODERATE',
        SEVERE = 'SEVERE',
    }
}

